module.exports = __webpack_public_path__ + "img/bg.ec64c495.svg";